'use client';

import PlaneIcon from '@/components/icons/Flights/PlaneIcon';
import PassengersColor from '@/components/icons/PassengersColor';
import CalendarColor from '@/components/illustratores/CalendarColor';
import Button from '@/components/ui/Button';
import { DatePickerModal } from '@/components/ui/DatePicker';
// Assuming useSubmitHotelSearch hook might need adjustments or a new hook for flights
// import { useSubmitHotelSearch } from '@/hooks/useSubmitHotelSearch';
import LocationIcon from '@/components/icons/Location';
import SmartBackButton from '@/components/SmartBackButton';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/DropDownMenu";
import { useSearchFlight } from '@/hooks/flight/useSearchFlight';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { faArrowRight, faArrowRightArrowLeft, faChevronDown, faChevronLeft, faPlusSquare, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, useEffect, useState } from 'react';
import FlightSearchInput from './FlightSearchInput';
import FlightTravelersModal from './FlightTravleresSelecorModal';



type RadioOptionProps = {
    label: string;
    value: string;
    checked: boolean;

    onChange: (value: string) => void;
};

function RadioOption({ label, value, checked, onChange, }: RadioOptionProps) {

    return (
        <label className={`
        ${checked ? 'bg-secondary-50 md:bg-white border-b md:border-b-0 text-secondary-500 border-secondary-500' : ''}
        py-2 cursor-pointer text-sm px-4 flex items-center rounded-t-lg gap-2 transition-all duration-200`}>
            <input
                className='md:inline-block hidden'
                type='radio'
                name='flightType'
                checked={checked}
                onChange={() => onChange(value)}
            />
            <span>{label}</span>
        </label>
    );
}

export default function FlightSearch({ withNavigate, applyOnChangeMobile }: { withNavigate?: boolean, applyOnChangeMobile?: boolean; }) {

    const {
        // UI states
        selectedOption,
        setSelectedOption,
        selectedType,
        setSelectedType,
        travelersData,
        setTravelersData,
        showTravelersModal,
        setShowTravelersModal,
        error,

        isGettingFlights,
        setIsGettingFlights,
        addFlightData,
        flightsData,
        setFromOriginAtIndex,
        setToOriginAtIndex,
        removeFlightDataAtIndex,
        changeOriginsAtIndex,

        // Derived and utility
        handleFlightDateChange,
        formatFlightDate,
        totalTravelers,
        pathname,

        // Actions
        handleSearch,
    } = useSearchFlight(withNavigate)

    const [isToInputSelected, setIsToInputSelected] = useState(false)
    const [isFromInputSelected, setIsFromInputSelected] = useState(false)

    const passModal = useOutsideClick(() => {
        innerWidth > 1024 && setShowTravelersModal(false);
    });

    useEffect(() => {
        if (pathname === '/' || pathname === '/services/flight') {
            setIsGettingFlights(false)
        }
    }, [pathname])

    return (
        <>
            <div className='hidden md:block text-sm py-1 text-gray-700 col-span-3 items-center gap-2.5'>
                <div className='flex items-center md:justify-start justify-between w-full '>
                    <RadioOption
                        label='Round-trip'
                        value='round-trip'
                        checked={selectedOption === 'round-trip'}
                        onChange={(value) => {
                            if (!flightsData[0].dates[1] && flightsData[0].dates[0]) {
                                handleFlightDateChange(0, {
                                    startDate: flightsData[0].dates[0],
                                    endDate: new Date(flightsData[0].dates[0].getTime() + 24 * 60 * 60 * 1000)
                                })
                            }
                            setSelectedOption(value)
                        }}
                    />
                    <RadioOption
                        label='One-way'
                        value='one-way'
                        checked={selectedOption === 'one-way'}
                        onChange={setSelectedOption}
                    />
                    {/* <RadioOption
                        label='Multi-city'
                        value='multi-city'
                        checked={selectedOption === 'multi-city'}
                        onChange={setSelectedOption}
                    /> */}
                    <div className='border-l hidden md:block pl-4'>
                        <DropdownMenu >
                            <DropdownMenuTrigger className='capitalize flex items-center gap-2'>
                                Cabin Type:  {selectedType}
                                <FontAwesomeIcon icon={faChevronDown} />
                            </DropdownMenuTrigger>
                            <DropdownMenuContent className='bg-white'>
                                <DropdownMenuItem onClick={() => setSelectedType('All')}>All</DropdownMenuItem>
                                <DropdownMenuItem onClick={() => setSelectedType('Economy')}>Economy</DropdownMenuItem>
                                <DropdownMenuItem onClick={() => setSelectedType('Business')} > Business</DropdownMenuItem>
                                <DropdownMenuItem onClick={() => setSelectedType('Premium')}> Premium</DropdownMenuItem>
                                <DropdownMenuItem onClick={() => setSelectedType('Firstclass')}> First Class</DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                    {selectedOption === 'multi-city' &&
                        <div ref={passModal}
                         onClick={() => setShowTravelersModal(true)} className='flex cursor-pointer items-center gap-2 ml-4 relative'>
                            <PassengersColor className='w-5' />
                            <div

                                className='flex flex-col text-gray-400'>
                                {/* Display total travelers */}
                                <span className='text-gray-900 text-sm'>
                                    {totalTravelers} Traveler{totalTravelers !== 1 ? 's' : ''}
                                </span>

                            </div>
                            <FlightTravelersModal
                                onClose={() => setShowTravelersModal(false)}
                                showModal={showTravelersModal}
                                setTravelersData={setTravelersData}
                                travelersData={travelersData}
                            />
                        </div>}
                </div >
                {flightsData.map((flight, index) => selectedOption !== 'multi-city' && index > 0 ? null : (
                    <div key={index} className={`${selectedOption === 'multi-city' ? 'md:grid-cols-[31px,repeat(3,_1fr),_auto]' : 'md:grid-cols-[repeat(4,_1fr),_auto]'} grid items-center mt-2  gap-2 md:gap-4 grid-cols-2 `}>
                        {selectedOption === 'multi-city' &&
                            <div className='bg-secondary-500 flex items-center justify-center 
                                            text-white rounded-lg h-full'>
                                {index + 1}
                            </div>
                        }
                        <div className='relative md:col-span-1 col-span-full'>
                            <button
                                onClick={() => changeOriginsAtIndex(index)}
                                className='absolute bg-secondary-50 z-20
                                         md:left-full md:top-1/2 md:-translate-y-1/2 md:-translate-x-3
                                        right-5 top-full -translate-y-4 md:right-auto
                                         text-secondary-500 size-10 p-2 
                                        rounded-xl border border-secondary-200 '>
                                <FontAwesomeIcon icon={faArrowRightArrowLeft} />
                            </button>
                            <FlightFormBox onClick={() => {
                                setIsToInputSelected(false)
                                setIsFromInputSelected(true)
                            }}>
                                <div className='border-b-2 border-main-500'>
                                    <PlaneIcon className='w-6' />
                                </div>
                                <div className='flex flex-col text-gray-400 grow'>
                                    <span className='text-xs font-normal'>From</span>
                                    <FlightSearchInput
                                        shouldFocus={isFromInputSelected}
                                        setSelectedAirport={(origin) => setFromOriginAtIndex(index, origin)}
                                        selectedAirport={flight.fromOrigin}
                                    />
                                </div>
                            </FlightFormBox>
                        </div>
                        <div onClick={() => {
                            setIsFromInputSelected(false)
                            setIsToInputSelected(true)
                        }}
                            className='md:col-span-1 col-span-full'
                        >
                            <FlightFormBox>
                                <div className='border-b-2 border-main-500'>
                                    <PlaneIcon className='w-6 rotate-45' />
                                </div>
                                <div className='flex flex-col text-gray-400'>
                                    <span className='text-xs font-normal'>To</span>
                                    <FlightSearchInput
                                        shouldFocus={isToInputSelected}
                                        setSelectedAirport={(origin) => setToOriginAtIndex(index, origin)}
                                        selectedAirport={flight.toOrigin}
                                    />
                                </div>
                            </FlightFormBox>
                        </div>
                        <DatePickerModal

                            singleDate={selectedOption !== 'round-trip'}
                            values={{
                                startDate: flight.dates[0], endDate:
                                    selectedOption === 'round-trip' ? flight.dates[1] : null
                            }}
                            onChange={(dates) => handleFlightDateChange(index, dates)}
                            buttonProps={{ className: 'md:col-span-1 cursor-pointer col-span-full relative' }}
                        >
                            <FlightFormBox>
                                <CalendarColor className='w-6' />

                                <div className='flex cursor-pointer flex-col text-gray-400'>
                                    <span className='text-xs font-normal'>Date</span>
                                    <span className='text-gray-500 text-base'>
                                        {formatFlightDate(flight.dates[0])}
                                        {selectedOption === 'round-trip' ? ' - ' + formatFlightDate(flight.dates[1]) : ''}
                                    </span>
                                </div>

                            </FlightFormBox>
                        </DatePickerModal>
                        {selectedOption !== 'multi-city' &&
                            <div onClick={() => setShowTravelersModal(s => !s)} className='relative cursor-pointer' ref={passModal}>
                                <FlightFormBox>
                                    <PassengersColor className='w-6' />
                                    <div

                                        className='flex flex-col text-gray-400'>
                                        <span className='text-xs font-normal'>Travelers</span>
                                        {/* Display total travelers */}
                                        <span className='text-gray-500 text-base'>
                                            {totalTravelers} Traveler{totalTravelers !== 1 ? 's' : ''}
                                        </span>

                                    </div>

                                </FlightFormBox>
                                <FlightTravelersModal
                                    onClose={() => setShowTravelersModal(false)}
                                    showModal={showTravelersModal}
                                    setTravelersData={setTravelersData}
                                    travelersData={travelersData}
                                />
                            </div>}
                        <div className='md:hidden h-full'>
                            <FlightFormBox>
                                <PassengersColor className='w-6' />
                                <div>
                                    Economy
                                </div>
                            </FlightFormBox>
                        </div>
                        <div className='col-span-2 md:col-span-1 flex items-center justify-center'>

                            {selectedOption === 'multi-city' ?
                                index > 0 ? <button onClick={() => removeFlightDataAtIndex(index)} className='hidden md:inline-block'>
                                    <FontAwesomeIcon icon={faX} />
                                </button> : <div className='w-3'> </div>
                                : <Button
                                    isLoading={isGettingFlights}
                                    onClick={() => handleSearch()} color='primary' className='h-fit mx-auto' radius='rounded-xl'>
                                    Search <span className='md:hidden'>Flights</span>
                                </Button>}
                        </div>
                    </div>))}
                {error.message &&
                    <p className='text-rose-500 text-sm font-normal mt-1'>{error.message}</p>}
                {selectedOption === 'multi-city' && <div className='flex mt-4 items-center justify-between'>

                    <Button onClick={() => addFlightData()} className='' color='light-secondary'>
                        Add Another Flight <FontAwesomeIcon icon={faPlusSquare} />
                    </Button>
                    <Button onClick={() => handleSearch()} color='primary'>
                        Search
                    </Button>
                </div>}
            </div >
            <div className='grid md:hidden grid-cols-[24px,_1fr,24px,_1fr] justify-items-center items-center gap-2'>

                <SmartBackButton customUrl='/'>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </SmartBackButton>
                <button className={`${error.type === 'location' ? 'border border-rose-500' : ''} 
                                    px-2 py-2.5 grid grid-cols-[24px,_1fr] gap-2 
                                    rounded-2xl bg-secondary-50 items-center`}
                >
                    <LocationIcon />
                    <div className='flex flex-col items-start'>
                        <span className=''>
                            {flightsData[0].fromOrigin.city_name ? flightsData[0].fromOrigin.city_name : 'From'}
                        </span>
                        <FlightSearchInput
                            onApplyMobile={(code) => {
                                if (applyOnChangeMobile) {
                                    handleSearch({ fromCode: code })
                                }
                            }}
                            setSelectedAirport={(origin) => setFromOriginAtIndex(0, origin)}
                            selectedAirport={flightsData[0].fromOrigin}
                        />
                    </div>
                </button>

                <FontAwesomeIcon className={'text-secondary-500'} icon={faArrowRight} />

                <button className={`${error.type === 'destination' ? 'border border-rose-500' : ''} 
                                    px-2 py-2.5 grid grid-cols-[24px,_1fr] gap-2 
                                    rounded-2xl bg-secondary-50 items-center`}
                >
                    <LocationIcon />
                    <div className='flex flex-col items-start'>
                        <span className=''>
                            {flightsData[0].toOrigin.city_name ? flightsData[0].toOrigin.city_name : 'To'}
                        </span>
                        <FlightSearchInput
                            onApplyMobile={(code) => {
                                if (applyOnChangeMobile) {
                                    setTimeout(() => {
                                        handleSearch({ toCode: code })
                                    }, 50);
                                    // push(`/flights/${fromOrigin.airport_code}-${code}?${getSearchParamsString()}`)
                                }
                            }}
                            setSelectedAirport={(origin) => setToOriginAtIndex(0, origin)}
                            selectedAirport={flightsData[0].toOrigin}
                        />
                    </div>
                </button>
            </div>
        </>
    );
}

function FlightFormBox({ children, onClick }: { children: ReactNode, onClick?: () => void }) {
    return <div onClick={onClick} className='border cursor-pointer relative h-full gap-4 border-gray-300 flex items-center rounded-xl px-4 py-3.5'>
        {children}
    </div>;
}
